export default {

    _toLoadVjsList : [],

    _loadingVjsList : [],

    readyToLoad : true,

    _isRunInV3Service(){
        return window.VMetrix&&window.VMetrix.loadBundles;
    },
    /**
     * 获取窗体域
     */
    _getWindowScope(){
        var scopeStack = window.VPlatformScope;
        if(scopeStack&& scopeStack.length > 0){
            return scopeStack[scopeStack.length - 1];
        }
        return null;
    },
    /**
     * @param {Array} vjsList 加载的vjs列表
     * @return {Promise}
     */
     loadVjs(vjsList){
        return new Promise((resolve,reject)=>{
            if(this._isRunInV3Service()){
                this._toLoadVjsList.push({
                    vjsList:vjsList,
                    resolve:resolve,
                    reject:reject
                });
                if(this.readyToLoad){
                    setTimeout(()=>{
                        let _VMetrix = window.VMetrix;
                        let vjs = [];
                        for(let i=0,l=this._toLoadVjsList.length;i<l;i++){
                            let item = this._toLoadVjsList[i];
                            this._loadingVjsList.push(item);
                            let vjsList = item.vjsList;
                            vjsList = typeof(vjsList)=='string' ? [vjsList]:vjsList;
                            for(let j=0,len=vjsList.length;j<len;j++){
                                let vjsName = vjsList[j];
                                if(vjs.indexOf(vjsName)==-1){
                                    vjs.push(vjsName);
                                }
                            }
                        }
                        this._toLoadVjsList = [];
                        var sandbox = _VMetrix.sandbox.create({
                            extensions:vjs
                        });
                        sandbox.active().done(()=>{
                            this.readyToLoad = true;
                            for(let i=0,l=this._loadingVjsList.length;i<l;i++){
                                let item = this._loadingVjsList[i];
                                item.resolve(sandbox);
                            }
                            this._loadingVjsList = [];
                        },(err)=>{
                            this.readyToLoad = true;
                            for(let i=0,l=this._loadingVjsList.length;i<l;i++){
                                let item = this._loadingVjsList[i];
                                item.reject(err);
                            }
                            this._loadingVjsList = [];
                        });
                    },1);
                }
                this.readyToLoad = false;
            }else{
                reject(new Error("未运行在V3服务内，无法执行操作."));
            }
        });    
    },
    /**
     * @param {Array}       vjsList 加载的vjs列表
     * @param {Function}    success 加载成功的回调，入参是sandbox
     * @param {Function}    error   加载失败的回调
     */
    loadVjsSync(vjsList,success,error){
        if(this._isRunInV3Service()){
            var _VMetrix = window.VMetrix;
            var sandbox = _VMetrix.sandbox.create({
                extensions:vjsList
            });
            sandbox.active().done(()=>{
                if(typeof(success) == "function")
                    success(sandbox);
            },(err)=>{
                if(typeof(error) == "function")
                    error(err);
            });
        }else{
            throw Error("未运行在V3服务内，无法执行操作.");
        }
    },

    /**
     * 参数是否给定
     * @param {Object} params 
     * @param {string} key 
     */
    assertParamDef(params,key){
        return params&&params.hasOwnProperty(key) ? true:false;
    },

    /**
     * 参数值不为null
     * @param {Object} params 
     * @param {string} key 
     */
    assertNotNull(params,key){
        if(this.assertParamDef(params,key)){
            let val = params[key];
            return val!==null&&typeof(val)!='undefined';
        }
        return false;
    }
};


// WEBPACK FOOTER //
// ./src/Utils.js